type MapLocale = 'ru_RU' | 'en_US'

/**
 * Возвращает локаль для карт на основе языка приложения.
 * Из-за ограниченного набора языков в Яндекс Картах
 * для русского возвращается русская локаль, для остальных языков - английская
 */
export const getMapLocale = (appLang: string): MapLocale => (appLang === 'ru' ? 'ru_RU' : 'en_US')
